import { render } from "./BetDetail.vue?vue&type=template&id=20fbcbcc&scoped=true"
import script from "./BetDetail.vue?vue&type=script&lang=js"
export * from "./BetDetail.vue?vue&type=script&lang=js"

import "./BetDetail.vue?vue&type=style&index=0&id=20fbcbcc&lang=less&scoped=true"

import exportComponent from "D:\\28\\前端\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20fbcbcc"]])

export default __exports__